import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import client from 'apollo/client';
import TICKET_FLAG_FRAGMENT from 'apollo/fragments/TICKET_FLAG_FRAGMENT';
import TICKET_STATE_FRAGMENT from 'apollo/fragments/TICKET_STATE_FRAGMENT';
import TICKET_TYPE_FRAGMENT from 'apollo/fragments/TICKET_TYPE_FRAGMENT';
import enumCollections from 'constants/enumCollections';
import { getDateAndTimeFormat } from 'utils/helpers/dateHelper';
import { safeRenderHTML } from 'utils/renderHelpers';
import { NoteBodyWrap } from './styled';
export var getFlagName = function (id) {
    if (!id)
        return 'No flag';
    var result = client.readFragment({
        id: "TicketFlag:".concat(id),
        fragment: TICKET_FLAG_FRAGMENT
    });
    if (result === null || result === void 0 ? void 0 : result.display_name)
        return result === null || result === void 0 ? void 0 : result.display_name;
    return id;
};
export var getTypeName = function (id) {
    var result = client.readFragment({
        id: "TicketType:".concat(id),
        fragment: TICKET_TYPE_FRAGMENT
    });
    if (result === null || result === void 0 ? void 0 : result.display_name)
        return result === null || result === void 0 ? void 0 : result.display_name;
    return id;
};
export var getStateName = function (id) {
    var result = client.readFragment({
        id: "TicketState:".concat(id),
        fragment: TICKET_STATE_FRAGMENT
    });
    if (result === null || result === void 0 ? void 0 : result.display_name)
        return result === null || result === void 0 ? void 0 : result.display_name;
    return id;
};
export var getPriorityName = function (index) { var _a, _b, _c; return ((_c = (_b = (_a = enumCollections === null || enumCollections === void 0 ? void 0 : enumCollections.TicketPriority) === null || _a === void 0 ? void 0 : _a.enumValues) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.name) || index; };
export var getAlarmDescription = function (text) {
    if (!text)
        return 'No alarm';
    var jsonText = text.replaceAll('=>', ':').replaceAll('nil', 'null');
    var value = JSON.parse(jsonText);
    if (!value)
        return 'No alarm';
    var notes = value.notes, datetime = value.datetime;
    if (!datetime)
        return 'No alarm';
    return "".concat(getDateAndTimeFormat(datetime)).concat(notes ? " with notes: ".concat(notes) : '');
};
export var getFollowupDescription = function (text) {
    if (!text)
        return 'No follow up';
    var jsonText = text.replaceAll('=>', ':').replaceAll('nil', 'null');
    var value = JSON.parse(jsonText);
    if (!value)
        return 'No follow up';
    var notes = value.notes, scheduled_at = value.scheduled_at;
    if (!scheduled_at)
        return 'No follow up';
    return "".concat(getDateAndTimeFormat(scheduled_at)).concat(notes ? " with notes: ".concat(notes) : '');
};
export var getNotesDescription = function (text) {
    if (!text)
        return 'No notes';
    var regex = /(<([^>]+)>)/gi;
    var result = text.replace(regex, '');
    if (result === '')
        return 'No notes';
    return result;
};
export var getNoteBodyDescription = function (text) { return (_jsx(NoteBodyWrap, { children: safeRenderHTML(text) })); };
export var getTagsDescription = function (stringifiedArray) {
    if (!stringifiedArray)
        return 'No tags';
    var array = JSON.parse(stringifiedArray);
    return array.join(', ');
};
export var getQueueDescription = function (string) {
    if (!string)
        return 'No queue';
    return string;
};
export var getDeliverableDescription = function (text) {
    var result = 'No deliverables';
    if (!text)
        return result;
    var jsonText = text.replaceAll('=>', ':').replaceAll('nil', 'null');
    var value = JSON.parse(jsonText);
    var keys = Object.keys(value);
    if (keys.length) {
        result = '';
        for (var i = 0; i < keys.length; i++) {
            result += "".concat(keys[i], ": ").concat(value[keys[i]]);
            if (i !== keys.length - 1)
                result += ', ';
        }
    }
    return result;
};
